"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bullet = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BootstrapHelper_1 = require("../..//BootstrapHelper");
var Bullet = function (props) {
    var cls = (0, BootstrapHelper_1.B)().bl("bullet")
        .bem;
    return (0, jsx_runtime_1.jsx)("span", { className: "".concat(cls, " ").concat(props.className || "") });
};
exports.Bullet = Bullet;
